import { createContext, useContext } from "react";

interface InteractiveSplitOverlay {
  title: string;
}

/**
 * Set by `InteractiveElementShell` inside its wide (split) overlay. That overlay
 * has no title bar. Content uses this to clear the corner close button; `title`
 * is the element title. `null` everywhere else.
 */
export const InteractiveSplitOverlayContext =
  createContext<InteractiveSplitOverlay | null>(null);

export const useInteractiveSplitOverlay = () =>
  useContext(InteractiveSplitOverlayContext);
